import { Icons } from "@/components/icons";
import { cn } from "@/lib/utils";

/**
 * L'attente de l'app : le logo seul, en respiration, centré dans la surface
 * qu'il occupera. Sert partout où l'écran ne peut pas encore montrer son vrai
 * contenu sans le montrer faux d'abord — chat dont le fil vit dans
 * localStorage, workspace dont les onglets ne sont pas encore restaurés.
 */
export function LogoLoading({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "flex min-h-0 flex-1 items-center justify-center",
        className,
      )}
    >
      <Icons.logo className="h-10 w-auto animate-pulse text-foreground dark:drop-shadow-[0_0_14px_rgba(255,255,255,0.35)]" />
    </div>
  );
}
